<script>
/**
 * Descripción del cambio para el control de versiones de los PDF.
 *
 * Se muestra solo al EDITAR un documento que ya existe: al crearlo la primera
 * versión se registra como "Emisión inicial". Lo que se escriba aquí queda en la
 * tabla CONTROL DE VERSIONES Y CAMBIOS del PDF, junto a la versión y el usuario.
 */
export default {
  name: "VersionNote",
  props: {
    value: { type: String, default: "" },
    // false al crear el documento (aún no hay versión anterior que describir)
    editing: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div v-if="editing" class="form-group vn-box">
    <label class="mb-1">
      Descripción del cambio
      <small class="text-muted">— para el control de versiones</small>
    </label>
    <b-form-input
      :value="value"
      :disabled="disabled"
      maxlength="150"
      placeholder="Ej: Se agregó la capacitación en alturas"
      @input="$emit('input', $event)"
    ></b-form-input>
    <small class="text-muted">
      Si modificas el documento se genera una versión nueva y este texto queda impreso en el PDF.
      Si lo dejas vacío se registra como “Modificación del documento”.
    </small>
  </div>
</template>

<style scoped>
.vn-box {
  border-left: 3px solid #1f4e8c;
  padding-left: 10px;
}
</style>
